import { FONT_SCALE_OPTIONS, type FontScale } from '@/lib/fontScale';

interface FontScaleSelectorProps {
  value: FontScale | null;
  onChange: (scale: FontScale) => void;
  disabled?: boolean;
}

/**
 * 文字サイズ（小/標準/大/特大）を選ぶ共通の選択UI。
 * 初回の必須ポップアップと、ヘッダーの変更モーダルの両方で使う。
 * 各選択肢には、その拡大率での見本テキストを表示する。
 */
export default function FontScaleSelector({
  value,
  onChange,
  disabled = false,
}: FontScaleSelectorProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {FONT_SCALE_OPTIONS.map((option) => {
        const active = value === option.key;
        return (
          <button
            key={option.key}
            type="button"
            onClick={() => onChange(option.key)}
            disabled={disabled}
            aria-pressed={active}
            className={`text-left rounded-lg border p-4 transition-colors cursor-pointer disabled:cursor-not-allowed ${
              active
                ? 'border-[color:var(--theme-primary)] bg-[color:var(--theme-primary-light)] ring-2 ring-[color:var(--theme-primary)]'
                : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'
            }`}
          >
            <div className="flex items-center justify-between mb-1">
              <span
                className={`text-sm font-bold ${
                  active ? 'text-[color:var(--theme-primary)]' : 'text-gray-900'
                }`}
              >
                {option.label}
              </span>
              <span
                className={`text-xs font-medium ${
                  active ? 'text-[color:var(--theme-primary)]' : 'text-gray-400'
                }`}
              >
                {option.percent}%
              </span>
            </div>
            <p className="text-xs text-gray-500 mb-2">{option.description}</p>
            <p
              className="text-gray-800 whitespace-nowrap overflow-hidden"
              style={{ fontSize: `${option.percent}%` }}
            >
              あいうえお 見本
            </p>
          </button>
        );
      })}
    </div>
  );
}